import Alpine from "../alpine.js"

Alpine.data("timedExercise", ({ units, quantity, sides, sets }) => ({
  units,
  quantity,
  sides,
  sets,
  setDuration: 0,
  currentSide: 1,
  currentSet: 1,
  timer: null,
  timerInterval: null,
  timerEnd: null,
  minutesLeft: 0,
  secondsLeft: 0,
  init () {
    if (this.units === "seconds") {
      this.setDuration = this.quantity
      this.secondsLeft = this.quantity
    } else if (this.units === "minutes") {
      this.setDuration = this.quantity * 60
      this.minutesLeft = this.quantity
    }
    console.log({ start: this.start })
  },
  start () {
    this.timerEnd = new Date((new Date().getTime() + this.setDuration * 1000))
    this.timer = setInterval(() => { this.tick() }, 1000)
    this.tick()
  },
  pause () {
    console.log("paused")
  },
  tick () {
    let millisecondsLeft = +this.timerEnd - new Date()

    if (millisecondsLeft > 1000) {
      this.minutesLeft = parseInt(millisecondsLeft/1000/60)
      this.secondsLeft = parseInt((millisecondsLeft/1000) % 60)
    } else {
      clearInterval(this.timer)

      this.next()
    }
  },
  next () {
    if (this.currentSide < this.sides) {
      this.currentSide = this.currentSide + 1
      this.start()
    } else if (this.currentSet < this.sets) {
      this.currentSide = 1
      this.currentSet = this.currentSet + 1
      this.start()
    } else {
      this.finish()
    }
  },
  finish () {
    console.log("finished")
  }
}))
